var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.blockId,staticClass:"rich-text-editor",style:(_vm.blockStyle),attrs:{"id":_vm.blockId}},[_c('div',{class:{
      'hidden': _vm.isDefaultText
    },domProps:{"innerHTML":_vm._s(_vm.clickableValue)}})])}
var staticRenderFns = []

export { render, staticRenderFns }